<template>
  <div>
    <div class="row">
      <div class="col-2"></div>
      <div class="col-3">Dati</div>
      <div class="col-3">Modificato da</div>
      <div class="col-3">In data</div>
    </div>
    <div class="row" v-for="update in updates">
      <div class="col-2" v-if="can_restore">
        <a class="btn btn-mini" href="#" @click="resumeModel(update.id)"
          ><i class="fas fa-history"></i
        ></a>
      </div>
      <div class="col-3" v-html="update.values"></div>
      <div class="col-3">{{ update.updated_by }}</div>
      <div class="col-3">{{ update.updated_at }}</div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.getHistory();
  },
  data() {
    return {
      updates: [],
      userUrl: this.is_admin ? "" : "-user",
    };
  },
  methods: {
    resumeModel(id) {
      Vue.swal
        .fire({
          title: "Vuoi ripristinare questo valore storico?",
          text: "",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Si",
        })
        .then((result) => {
          if (result.value) {
            axios
              .put("/history-model-revert" + this.userUrl + "/" + id)
              .then((response) => {
                app.__vue__.$refs.profile_person_skill.populateSkillTable();
                app.__vue__.$refs.vue_popup.active = false;
              })
              .catch(function (error) {
                alert(error);
              });
          }
        });
    },

    getHistory() {
      axios
        .get("/history-model" + this.userUrl, {
          params: {
            model_id: this.model_id,
            model_type: this.model_type,
          },
        })
        .then((response) => {
          this.updates = response.data;
        })
        .catch(function (error) {
          alert(error);
        });
    },
  },
  props: {
    model_id: {
      type: Number,
      required: true,
    },
    model_type: {
      type: String,
      required: true,
    },
    is_admin: {
      type: Boolean,
      required: true,
    },
    can_restore: {
      type: Boolean,
      required: true,
    },
  },
};
</script>

<style>
</style>
